
import React, { useState } from 'react';
import { TextField, DateField} from "ra-ui-materialui";
import '../../resources/resources.css';
import { List, Datagrid } from 'react-admin';
import { RecordsFormDialog } from "../RecordsFormDialog";

export const ExceptionTable = (props) => {
    const [openDialog, setOpenDialog] = useState(false);
    const [recordId, setRecordId] = useState();

    const { ...restProps } = props;

    const handleRowClick = (id, resource, record) => {
        setRecordId(record?.id);
        setOpenDialog(true);
    };

    return (
        <> 
            <List 
                {...restProps}  
                title={<span />}
                hasCreate={false}
                exporter={false}
                filterDefaultValues={{
                    ...(props.isProfessional
                      ? { profesionalId: props?.id + "" }
                      : { clientId: props?.id + "" })
                  }}                
                sort={{ field: 'Id', order: 'DESC' }}
                bulkActionButtons={false} 
            >
                <Datagrid     
                    rowClick={props?.mode === 'show' ?  false : handleRowClick}                    
                    headerOptions={{
                        disableSelectAll: true,
                    }}>
                    <TextField label="Nombre" source="name" />
                    <DateField label="Fecha Inicio" source="startDate" />
                    <DateField label="Fecha Fin" source="endDate" />
                    <TextField label="Hora Inicio" source="startTime" />
                    <TextField label="Hora Fin" source="endTime" />                    
                </Datagrid>
            </List>
            <RecordsFormDialog 
                        {...props}
                        open={openDialog} 
                        onClose={() => setOpenDialog(false)} 
                        onsaved={() => {
                            setOpenDialog(false)
                        }} 
                        isModal={true}
                        mode={'edit'}
                        resource="records"
                        isRecord={true}
                        id={recordId+ ""}
                    />
        </>
    );
};


export default ExceptionTable;
